export const PAYROLL_REQUEST = "PAYROLL_REQUEST";
export const PAYROLL_SUCCESS = "PAYROLL_SUCCESS";
export const PAYROLL_FAILURE = "PAYROLL_FAILURE";